import { render } from "./MeusPedidosView.vue?vue&type=template&id=9406ca5e&scoped=true"
import script from "./MeusPedidosView.vue?vue&type=script&lang=js"
export * from "./MeusPedidosView.vue?vue&type=script&lang=js"

import "./MeusPedidosView.vue?vue&type=style&index=0&id=9406ca5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9406ca5e"]])

export default __exports__